export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FALIURE = 'LOGIN_FALIURE'
export const DEVICE_REQUEST = 'DEVICE_REQUEST'
export const DEVICE_SUCCESS = 'DEVICE_SUCCESS'
export const DEVICE_FALIURE = 'DEVICE_FALIURE'

